// AnalysisRise.tsx
import { Box, Button, Divider, Grid, TextField, Typography, useMediaQuery, useTheme } from '@mui/material';
import { ChangeEvent } from 'react'; 
import { Remove, Add } from '@mui/icons-material';
import { AnaliseEstabilidade, InfoAnalises } from '../../../../services/api/reports/ReportsServicesRise';

interface AnalysisRiseProps {
    data: AnaliseEstabilidade;
    onAnalysisChange: (data: AnaliseEstabilidade) => void;
}

export const AnalysisRise = ({ data, onAnalysisChange }: AnalysisRiseProps) => {

    const theme = useTheme();
    const smDown = useMediaQuery(theme.breakpoints.down('sm'));


    const handleAdd = () => {
        onAnalysisChange({
            ...data, 
            informacoes: [...(data.informacoes || []), {} as InfoAnalises],
        });
    };

    const handleRemove = (index: number) => {
        onAnalysisChange({
            ...data,
            informacoes: data.informacoes.filter((_, i) => i !== index),
        });
    };

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        const { id, value } = e.target;
        onAnalysisChange({
            ...data,
            [id]: value, 
        });
    };

    const handleAnomaliasChange = (index: number, fieldName: keyof InfoAnalises, value: string) => {
        const updatedInformacoes = [...(data.informacoes || [])]; 
        updatedInformacoes[index] = {
            ...updatedInformacoes[index], 
            [fieldName]: value
        };
        onAnalysisChange({
            ...data,
            informacoes: updatedInformacoes 
        });
    };

    return (
        <Box>
            <Box>
                <Grid container marginBottom={2}>
                    <Grid item xs={12}>
                        <Typography variant='h5'>Análises de estabilidade</Typography>
                        <Divider />
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={smDown ? 12 : 6}>
                        <TextField
                            InputLabelProps={{ shrink: true }}
                            label='Modos de falha considerados'
                            value={data.modos_falha || ''}
                            id='modos_falha'
                            fullWidth
                            multiline
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6}>
                        <TextField
                            InputLabelProps={{ shrink: true }}
                            label='Método de Análise (principal)'
                            value={data.metodo_analise || ''}
                            id='metodo_analise'
                            fullWidth
                            multiline
                            onChange={handleChange}
                        />
                    </Grid>
                </Grid>
                <Grid container marginBottom={2} marginTop={2}>
                    <Grid item xs={12}>
                        <Typography variant='h5'>Materiais e parâmetros</Typography>
                        <Divider />
                    </Grid>
                </Grid>
                <Grid container justifyContent={'center'}>
                    <Grid item xs={smDown ? 12 : 6} display="flex" justifyContent="center">
                        <Button
                            startIcon={<Remove />}
                            onClick={() => data.informacoes.length > 0 && handleRemove(data.informacoes.length - 1)}
                            disabled={data.informacoes.length === 0}
                        >
                            Remover
                        </Button>
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6} display="flex" justifyContent="center">
                        <Button
                            startIcon={<Add />}
                            onClick={handleAdd}
                        >
                            Adicionar
                        </Button>
                    </Grid>
                </Grid>
                {(data.informacoes || []).map((item, index) => (
                    <Box key={index} padding={1}>
                        <Grid container spacing={2}>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField
                                    InputLabelProps={{ shrink: true }}
                                    label='Seção'
                                    id='secao'
                                    fullWidth
                                    value={item.secao || ''}
                                    onChange={(e) => handleAnomaliasChange(index, 'secao', e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField
                                    InputLabelProps={{ shrink: true }}
                                    label='Condição'
                                    id='condicao'
                                    fullWidth
                                    value={item.condicao || ''}
                                    onChange={(e) => handleAnomaliasChange(index, 'condicao', e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField
                                    InputLabelProps={{ shrink: true }}
                                    label='Fator de Segurança'
                                    id='fator_seguranca'
                                    fullWidth
                                    value={item.fator_seguranca || ''}
                                    onChange={(e) => handleAnomaliasChange(index, 'fator_seguranca', e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField
                                    InputLabelProps={{ shrink: true }}
                                    label='Valor de Referência (NBR 13028/2017)'
                                    id='valor_referencia'
                                    fullWidth
                                    value={item.valor_referencia || ''}
                                    onChange={(e) => handleAnomaliasChange(index, 'valor_referencia', e.target.value)}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                ))}
            </Box>
        </Box>
    );
}; 